const PREFIX = 'ERROR';

export class SET_ERROR_FLAG {
    static readonly type = `[${PREFIX}] SET ERROR FLAG`;
    constructor(public readonly payload ) {}    
}

export class SET_ERROR_MESSAGE {
    static readonly type = `[${PREFIX}] SET ERROR MESSAGE`;
    constructor(public readonly payload ) {}    
}

export class RESET_ERROR_MESSAGE {
    static readonly type = `[${PREFIX}] RESET ERROR MESSAGE`;
}
